import React, { useState } from 'react';
import { Layout, Menu, Typography } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
    DashboardOutlined,
    BankOutlined,
    TeamOutlined,
    UserOutlined,
    TagsOutlined,
    TrophyOutlined,
    DollarOutlined,
    MailOutlined,
    SettingOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    FileTextOutlined,
} from '@ant-design/icons';
import type { MenuProps } from 'antd';

const { Sider, Content } = Layout;
const { Title } = Typography;

type MenuItem = Required<MenuProps>['items'][number];

const AdminLayout: React.FC = () => {
    const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const menuItems: MenuItem[] = [
        {
            key: '/admin/dashboard',
            icon: <DashboardOutlined />,
            label: 'Дашборд',
        },
        {
            key: '/admin/federations',
            icon: <BankOutlined />,
            label: 'Федерации',
        },
        {
            key: '/admin/clubs',
            icon: <TeamOutlined />,
            label: 'Клубы',
        },
        {
            key: '/admin/managers',
            icon: <UserOutlined />,
            label: 'Менеджеры',
        },
        {
            key: '/admin/coaches',
            icon: <UserOutlined />,
            label: 'Тренеры',
        },
        {
            key: '/admin/participants',
            icon: <TeamOutlined />,
            label: 'Спортсмены',
        },
        {
            key: '/admin/categories',
            icon: <TagsOutlined />,
            label: 'Категории',
        },
        {
            key: '/admin/tournaments',
            icon: <TrophyOutlined />,
            label: 'Турниры',
        },
        {
            key: '/admin/subscription-plans',
            icon: <DollarOutlined />,
            label: 'Планы подписок',
        },
        {
            key: '/admin/promo-codes',
            icon: <DollarOutlined />,
            label: 'Промокоды',
        },
        {
            key: '/admin/subscriptions',
            icon: <DollarOutlined />,
            label: 'Подписки',
        },
        {
            key: '/admin/email-settings',
            icon: <MailOutlined />,
            label: 'Настройки почты',
        },
        {
            key: '/admin/email-templates',
            icon: <MailOutlined />,
            label: 'Шаблоны писем',
        },
        {
            key: '/admin/system-parameters',
            icon: <SettingOutlined />,
            label: 'Параметры платформы',
        },
        {
            key: '/admin/info-blocks',
            icon: <FileTextOutlined />,
            label: 'Блоки информации',
        },
        {
            key: '/admin/docs',
            icon: <FileTextOutlined />,
            label: 'Документация',
        },
    ];

    const handleMenuClick = ({ key }: { key: string }) => {
        navigate(key);
    };

    // Определяем выбранный ключ меню на основе текущего пути
    const selectedKey = location.pathname.startsWith('/admin/') 
        ? location.pathname 
        : '/admin/dashboard';

    return (
        <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>
            <Sider
                trigger={null}
                collapsible
                collapsed={collapsed}
                style={{
                    overflow: 'auto',
                    height: '100vh',
                    position: 'fixed',
                    left: 0,
                    top: 64,
                    bottom: 0,
                    background: '#001529',
                }}
                width={250}
            >
                <div style={{ 
                    padding: '16px', 
                    color: 'white', 
                    textAlign: 'center',
                    borderBottom: '1px solid #1890ff',
                    marginBottom: 8
                }}>
                    <Title level={4} style={{ color: 'white', margin: 0 }}>
                        Админ панель
                    </Title>
                </div>
                <Menu
                    theme="dark"
                    mode="inline"
                    selectedKeys={[selectedKey]}
                    items={menuItems}
                    onClick={handleMenuClick}
                    style={{ borderRight: 0 }}
                />
            </Sider>
            <Layout style={{ marginLeft: collapsed ? 80 : 250, transition: 'margin-left 0.2s' }}>
                <div style={{ 
                    position: 'fixed',
                    left: collapsed ? 80 : 250,
                    top: 64,
                    zIndex: 100,
                    background: '#fff',
                    padding: '8px 16px',
                    borderRadius: '0 0 8px 0',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                    transition: 'left 0.2s',
                    cursor: 'pointer'
                }}
                onClick={() => setCollapsed(!collapsed)}
                >
                    {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                </div>
                <Content
                    style={{
                        margin: '24px',
                        padding: '24px',
                        background: '#fff',
                        borderRadius: '8px',
                        minHeight: 'calc(100vh - 112px)',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                    }}
                >
                    <Outlet />
                </Content>
            </Layout>
        </Layout>
    );
};

export default AdminLayout;

